import React from 'react';
// import { Redirect } from 'react-router-dom';
import { Redirect, Link } from 'react-router-dom';
import { Card, Image } from 'semantic-ui-react';
import ArtistDetail from '../artist/artistDetailsModal';
import { inject, observer } from "mobx-react";

@inject('userStore', 'navigatorStore', 'authStore', 'landingPageArtworksStore', 'artworksStore', 'artistDetails', 'followAndLikeStore')
@observer
export default class artistCard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            clickedOnArtist: false,
            openArtistModal: {}
        }
    }
    resetClickedOnArtist() {
        this.setState({
            clickedOnArtist: false
        })
    }
    handleArtistClickInArtist(e, item) {

        // if (!localStorage.hasOwnProperty("userData")) {
        //     this.props.navigatorStore.openSignInModal();
        //     return;
        // }

        // console.log("recieved to send as props", item)

        e.preventDefault();
        this.setState({

            clickedOnArtist: true,
            clickedArtistId: item
        }, function () {
            // console.log("[mounted]", this.state.openArtistModal)
        })
        // this.props.navigatorStore.openArtistDetailsModal();
        // console.log("contextmenu,do something else")
    }
    // addMenu.popup(e.clientX, e.clientY);


    // e.preventDefault();

    // this.setState({
    //     clickedOnArtwork: true,
    //     clickedArtworkId: item
    // })




    render() {
        if (this.state.clickedOnArtist) {
            // return (
            window.open(`/profile/details/${this.state.clickedArtistId}`, '_blank')
            this.resetClickedOnArtist()
            // )
            // return (
            //     <Redirect push to={{
            //         pathname: `/profile/details/${this.state.clickedArtistId}`,
            //         state: { id: this.state.clickedArtistId }
            //     }} />
            // )
        }
        return (
            <div className="row" >
                {this.state.openModal && <ArtistDetail details={this.state.openArtistModal}></ArtistDetail>}
                <ArtistCardHolder artistData={this.props.artistData} handleArtistClickInArtist={this.handleArtistClickInArtist.bind(this)} />
            </div>
        )
    }
}


const ArtistCardHolder = (props) => {
    let { artistData } = props;
    // console.log("[artist data props]", artistData)
    return (
        (artistData && artistData.length > 0)
            ? artistData.map((el, elIndex) =>
                <div className="col-12 col-sm-4 col-md-4 col-lg-3 col-xl-3" key={elIndex}>

                    <div className="featured-artists-card" >
                        {/* <Link
                            to={props.clickedOnArtist && `/profile/details/${el.id}`}
                            className="artworks-image"
                            onContextMenu={(e) => props.handleArtistClick(e, el.id)}
                        > */}
                        {/* <a
                            target='_blank'
                            href={`/profile/details/${el.share_url.substr(el.share_url.lastIndexOf("/") + 1)}`}> */}
                            <Image className="featured-artists-card-image"
                                onClick={(e) => props.handleArtistClickInArtist(e, el.share_url.substr(el.share_url.lastIndexOf("/") + 1))} 
                                key={elIndex}
                                src={el.image || require('../../assets/default_square_picture.png')} />
                            {/* </Link> */}
                        {/* </a> */}
                        <Card.Content>
                            <Card.Description className="user-data">
                                <div className="artist-name">{el.full_name}</div>
                                {/* <div className="artist-name">{(el.display_name) ? el.display_name : el.old_display_name}</div> */}
                                <hr className="user-data-line" />
                                <p className="user-location">{(!!el.city) ? `${el.city}, ` : ""}{el.country}</p></Card.Description>
                        </Card.Content>
                    </div>
                </div>
            )
            : <div></div>
    )
}



// WEBPACK FOOTER //
// ./src/components/cardHolders/artistsCard.js